import {
  type MulticityFlightSearchQueryParamValues,
  FlightSearchQueryParams,
} from "@b2bportal/core-types";
import { MAX_MULTICITY_ROUTES } from "@hopper-b2b/types";

type MulticitySegment = {
  origin: string;
  destination: string;
  departureDate: string;
};

export const extractMulticitySegmentsFromQueryParams = (
  source: Partial<
    Record<
      keyof MulticityFlightSearchQueryParamValues,
      string | number | boolean | null | undefined
    >
  >
): MulticitySegment[] =>
  Array.from({ length: MAX_MULTICITY_ROUTES }, (_, index) => ({
    origin: source[`${FlightSearchQueryParams.ORIGIN}${index}`],
    destination: source[`${FlightSearchQueryParams.DESTINATION}${index}`],
    departureDate: source[`${FlightSearchQueryParams.DEPARTURE_DATE}${index}`],
  })).filter(
    (seg): seg is MulticitySegment =>
      seg.origin != null && seg.destination != null && seg.departureDate != null
  );
